import React from 'react'

export function useMultiFileInput(
  doc: { createElement: typeof document.createElement },
  accept: string[],
  onFilesSelected: (files: File[]) => void,
) {
  const inputRef = React.useRef<HTMLInputElement|null>(null)

  const initializeInput = () => {
    inputRef.current = createFileInput(doc, true, accept)
    inputRef.current.onchange = (e: Event) => {
      const input = e.target as HTMLInputElement
      const files = input.files
      files && onFilesSelected(Array.from(files))
      initializeInput()
    }
  }

  React.useEffect(() => {
    initializeInput()
    return () => {
      if (inputRef.current) {
        inputRef.current.onchange = null
      }
    }
  }, [accept, onFilesSelected])

  const openFilePicker = () => {
    if (inputRef.current) {
      inputRef.current.click()
    }
  }

  return { openFilePicker, resetInput: initializeInput }
}

function createFileInput(
  doc: { createElement: typeof document.createElement },
  multiple: boolean,
  accept: string[]
) {
  const input = doc.createElement('input') as HTMLInputElement
  input.type = 'file'
  input.multiple = multiple || false
  input.accept = accept.join(',')
  return input
}

